var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "copyright-block" }, [
    _c("p", [
      _vm._v("©" + _vm._s(_vm.year) + " Asoko Insight. All right reserved."),
    ]),
    _vm._v(" "),
    _c("p", [_vm._v("We will respect your privacy.")]),
    _vm._v(" "),
    _vm._m(0),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", [
      _c("a", { attrs: { href: "/about/legal" } }, [_vm._v("See our terms.")]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }